<div class="wrapper">
<kendo-tabstrip>
    <kendo-tabstrip-tab title="{{ 'title.gaminiu.perziura.' + regPerziura.srautoKodas | translate }}" [selected]="true">

      <ng-template kendoTabContent>
        <div class="tab-content-wrapper">
          <ng-container *ngIf="sharedDataService.getIsLoading() | async; else showPerziura">
            <div class="k-loading-mask">
              <div class="k-loading-image"></div>
            </div>
          </ng-container>

          <ng-template kendoTabContent #showPerziura>
            <div class="content">
              <div class="duomenu-perziura-style" *ngIf="giiRegistracijaApi.sustabdytaNuo">
                <label class="title">
                  {{ 'title.sustabdymo.informacija' | translate }}
                </label>
                <div class="row">
                  <div class="col">
                    <label class="label">
                      {{ 'label.sustabdyta.nuo' | translate }}
                    </label>
                    <div>{{ giiRegistracijaApi.sustabdytaNuo | date: 'yyyy-MM-dd' }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.sustabdyta.iki' | translate }}
                    </label>
                    <div>{{ giiRegistracijaApi.sustabdytaIki | date: 'yyyy-MM-dd' }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.sustabdymo.priezastis' | translate }}
                    </label>
                    <div>{{ giiRegistracijaApi.sustabdymoPriezastis}}</div>
                  </div>
                </div>
              </div>
              <div class="duomenu-perziura-style">
                <div class="row">
                  <div class="col">
                    <label class="label">
                      {{ 'label.srautas' | translate }}
                    </label>
                    <div>{{ translateClassifierLabel(giiRegistracijaApi.srautoId) }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.busena' | translate }}
                    </label>
                    <div>{{ ('label.busena.' + giiRegistracijaApi.busena) | translate }}</div>
                  </div>
                  <div class="col">
                  </div>
                </div>
              </div>
              <div class="duomenu-perziura-style">
                <label class="title">
                  {{ 'title.subjekto.duomenys' | translate }}
                </label>
                <div class="row">
                  <div class="col">
                    <label class="label">
                      {{ 'label.imones.pavadinimas' | translate }}
                    </label>
                    <div>{{ subjektasApi.pavadinimas }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.imones.kodas' | translate }}
                    </label>
                    <div>{{ subjektasApi.kodas }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.subjekto.tipas' | translate }}
                    </label>
                    <div>{{ ('label.tipas.' + subjektasApi.tipas) | translate }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.adresas' | translate }}
                    </label>
                    <div>{{ subjektasApi.adresas }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label class="label">
                      {{ 'label.telefono.nr' | translate }}
                    </label>
                    <div>{{ subjektasApi.telefonas }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.fakso.nr' | translate }}
                    </label>
                    <div>{{ subjektasApi.faksas }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.el.pasto.adresas' | translate }}
                    </label>
                    <div>{{ subjektasApi.elPastas }}</div>
                  </div>
                  <div class="col">
                  </div>
                </div>
              </div>
              <div class="duomenu-perziura-style">
                <label class="title">
                  {{ 'label.rysio.duomenys' | translate }}
                </label>
                <div class="row">
                  <div class="col">
                    <label class="label">{{ 'label.asm.vardas.pavarde' | translate }}</label>
                    <div>{{ subjektasApi.asmRysiams }}</div>
                  </div>
                  <div class="col">
                    <label class="label">{{ 'label.telefono.nr' | translate }}</label>
                    <div>{{ subjektasApi.telefonas }}</div>
                  </div>
                  <div class="col">
                    <label class="label">{{ 'label.el.pasto.adresas' | translate }}</label>
                    <div>{{ subjektasApi.elPastas }}</div>
                  </div>
                </div>
              </div>
              <div class="duomenu-perziura-style">
                <label class="title">
                  {{ 'label.gii.veiklos.budai.atsakomybes.budai' | translate }}
                </label>
                <div class="row">
                  <div class="col">
                    <label class="label">
                      {{ 'label.registracijos.data' | translate }}
                    </label>
                    <div>{{ giiRegistracijaApi.regData | date: 'yyyy-MM-dd' }}</div>
                  </div>
                  <div class="col">
                    <label class="label">
                      {{ 'label.koregavimo.data' | translate }}
                    </label>
                    <div  *ngIf="giiRegistracijaApi.giiRegKoregavimasApiList && giiRegistracijaApi.giiRegKoregavimasApiList.length > 0">
                      {{ getLatestKoregData() | date: 'yyyy-MM-dd' }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="duomenu-perziura-style" style="background-color: #EAF5F2">
                <ng-container>
                  <ng-container *ngFor="let item of giiRegistracijaApi.giiSrautasApiList">
                    <div class="row">
                      <div class="col">
                        <label class="title">{{ getSrautoClWithDates(item.srautoTipoId, giiRegistracijaApi.clKodas) }}</label>
                        <hr class="hr-under-line">
                        <div class="col">
                          {{ 'label.pradeta.tiekti.rinkai.nuo' | translate }} {{ item.tiektaNuo | date: 'yyyy-MM-dd' }}
                        </div>
                        <div *ngIf="item.tiektaIki" class="col">
                          {{ 'label.tiekta.rinkai.iki' | translate }} {{ item.tiektaIki | date: 'yyyy-MM-dd' }}
                        </div>
                        <div class="col">
                          <label class="label"><u>
                            {{ 'label.veiklos.budai' | translate }}
                          </u></label>
                          <ng-container *ngFor="let veiklosBudai of item.giiVeiklosBudasApiList">
                            <div>
                              {{ generateVeiklosBudai(veiklosBudai.clvklId, veiklosBudai.giiAtsakBudasApiList) }}
                            </div>
                          </ng-container>
                        </div>
                        <div class="col">
                          <ng-container *ngFor="let veiklosPrekybosBudai of item.giiVeiklosBudasApiList">
                            <label *ngIf="veiklosPrekybosBudai.clvklId === this.getClPvId()" class="label"><u>
                              {{ 'label.prekybos.lr.vidaus.rinkai.budai' | translate }}
                            </u></label>
                            <ng-container *ngFor="let veiklosPrekybosBudaiTest of veiklosPrekybosBudai.giiVeiklosPrekybosBudasApiList">
                              <div>
                                {{ generateVeiklosBudai(veiklosPrekybosBudaiTest.clprkId, null) }}
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="{{ 'title.busenu.istorija' | translate }}">
      <ng-template kendoTabContent class="row">
        <div class="col">
          <div>
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <label class="title">{{ 'title.busenu.istorija' | translate }}</label>
              <button kendoButton themeColor="primary" fillMode="outline" (click)="this.printGrid()" [disabled]="this.isPrinting">
                {{ 'button.print' | translate }}
              </button>
            </div>
            <hr class="hr-under-line">
            <kendo-grid [data]="busenuIstorija"
                        [kendoGridBinding]="busenuIstorija"
                        (cellClick)="onRowSelect($event.dataItem)"
                        [height]="300"
                        [class]="'selectable-grid'"
                        [selectable]="true"
                        [sortable]="true"
                        [sort]="[{ field: 'koregData', dir: 'desc' }]">
              <kendo-grid-column field="koregData" title="{{ 'grid.title.data.ir.laikas' | translate }}" [width]="15">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.koregData | date: 'yyyy-MM-dd HH:mm' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="senaBusena" title="{{ 'grid.title.buvusi.busena' | translate }}" [width]="15">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{
                  dataItem.senaBusena !== null ? ('label.busena.' + dataItem.senaBusena | translate) : '-'
                  }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="busena" title="{{ 'grid.title.nauja.busena' | translate }}" [width]="15">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ 'label.busena.' + dataItem.busena | translate}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="koregPriezastis" title="{{ 'grid.title.duomenu.koreg.priezastis' | translate }}" [width]="35">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{
                  isEnumValue(dataItem.koregPriezastis)
                    ? ('label.koreg.' + dataItem.koregPriezastis | translate)
                    : dataItem.koregPriezastis
                  }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="koregAsmuo" title="{{ 'grid.title.naudotojas.pakeites.busena' | translate }}" [width]="20"> </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
        <div style="padding-top: 10px" class="col" *ngIf="isRowSelected">
          <label class="title">{{ 'title.duomenu.pakeitimo.istorija' | translate }}</label>
          <hr class="hr-under-line">
          <kendo-grid [data]="selectedRow.giiRegIstorijaApiList">
            <kendo-grid-column field="tipas" title="{{ 'grid.title.tipas' | translate }}" [width]="20">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.tipas.includes('label') ? (dataItem.tipas | translate) : translateClassifierLabel(dataItem.tipas) }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="laukoPav" title="{{ 'grid.title.lauko.pavadinimas' | translate }}" [width]="20">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.laukoPav | translate }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="senaReiksme" title="{{ 'grid.title.buvusi.reiksme' | translate }}" [width]="15">
              <ng-template kendoGridCellTemplate let-dataItem>
                <td>{{ formatValue(dataItem, 'senaReiksme') }}</td>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="naujaReiksme" title="{{ 'grid.title.nauja.reiksme' | translate }}" [width]="15">
              <ng-template kendoGridCellTemplate let-dataItem>
                <td>{{ formatValue(dataItem, 'naujaReiksme') }}</td>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
<div class="pdf-hidden" *ngIf="loadPdf">
  <kendo-pdf-export #pdfExport [landscape]="true" [scale]="0.7" paperSize="A4" [margin]="20">
    <div *ngFor="let row of busenuIstorija" class="pdf-page">
      <h3>{{ 'title.busenu.istorija' | translate }}</h3>

      <table class="pdf-table">
        <thead>
        <tr>
          <th>{{ 'grid.title.data.ir.laikas' | translate }}</th>
          <th>{{ 'grid.title.buvusi.busena' | translate }}</th>
          <th>{{ 'grid.title.nauja.busena' | translate }}</th>
          <th>{{ 'grid.title.duomenu.koreg.priezastis' | translate }}</th>
          <th>{{ 'grid.title.naudotojas.pakeites.busena' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ row.koregData | date: 'yyyy-MM-dd HH:mm' }}</td>
          <td>{{ row.senaBusena ? ('label.busena.' + row.senaBusena | translate) : '-' }}</td>
          <td>{{ 'label.busena.' + row.busena | translate }}</td>
          <td class="wrap-text">
            {{
            isEnumValue(row.koregPriezastis)
              ? ('label.koreg.' + row.koregPriezastis | translate)
              : row.koregPriezastis
            }}
          </td>
          <td>{{ row.koregAsmuo }}</td>
        </tr>
        </tbody>
      </table>

      <div *ngIf="row.giiRegIstorijaApiList?.length">
        <h4>{{ 'title.duomenu.pakeitimo.istorija' | translate }}</h4>

        <table class="pdf-table">
          <thead>
          <tr>
            <th>{{ 'grid.title.tipas' | translate }}</th>
            <th>{{ 'grid.title.lauko.pavadinimas' | translate }}</th>
            <th>{{ 'grid.title.buvusi.reiksme' | translate }}</th>
            <th>{{ 'grid.title.nauja.reiksme' | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of row.giiRegIstorijaApiList">
            <td>{{ item.tipas.includes('label') ? (item.tipas | translate) : translateClassifierLabel(item.tipas) }}</td>
            <td>{{ item.laukoPav | translate }}</td>
            <td>{{ formatValue(item, 'senaReiksme') }}</td>
            <td>{{ formatValue(item, 'naujaReiksme') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </kendo-pdf-export>
</div>
